import { defineComponent as _defineComponent } from 'vue'
import { Autoplay, Pagination, Navigation } from 'swiper'


export default /*#__PURE__*/_defineComponent({
  __name: 'Image',
  props: {
  loop: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

const modules = [Autoplay, Pagination, Navigation]

const __returned__ = { props, modules, get Autoplay() { return Autoplay }, get Pagination() { return Pagination }, get Navigation() { return Navigation } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})